import { apiSlice } from 'api/apiSlice'

const pagesAdminApi = apiSlice.injectEndpoints({
  endpoints: build => ({
    pageContent: build.query({
      query: slug => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/pages/${slug}`,
      }),
    }),
  }),
})

export const { usePageContentQuery } = pagesAdminApi
